import { getSessionKey } from './utils';
import { getCurrentLanguage } from './translation';

const CURRENCIES = {
  USD: {
    symbol: '$',
    name: 'US Dollar',
    symbol_native: '$',
  },
  EUR: {
    symbol: '€',
    name: 'Euro',
    symbol_native: '€',
  },
  GBP: {
    symbol: '£',
    name: 'British Pound Sterling',
    symbol_native: '£',
  },
  CAD: {
    symbol: 'CA$',
    name: 'Canadian Dollar',
    symbol_native: '$',
  },
  MXN: {
    symbol: 'MX$',
    name: 'Mexican Peso',
    symbol_native: '$',
  },
};

const formatDecimalNumberWithSeparators = (value, decimal = 2, locale) => {
  const currentLanguage = getCurrentLanguage();
  const currentLocale = locale || currentLanguage === 'de' ? 'de-DE' : 'en-US';
  const number = Number(value);
  if (Number.isNaN(number)) {
    return '0';
  }
  return number.toLocaleString(currentLocale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  });
};

export const formatCurrency = (value, currency) => {
  const localCurrency = currency || getSessionKey('userCurrency') || 'EUR';
  const { symbol } = CURRENCIES[localCurrency];
  return `${formatDecimalNumberWithSeparators(value)} ${symbol}`;
};

